export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TESTIDS = {
  nav: {
    logo: "nav-logo",
    services: "nav-services-link",
    cities: "nav-cities-link",
    about: "nav-about-link",
    insights: "nav-insights-link",
    contact: "nav-contact-link",
    quote: "nav-quote-cta",
    langToggle: "nav-lang-toggle",
    mobileMenu: "nav-mobile-menu",
  },
  hero: {
    root: "hero-root",
    kicker: "hero-kicker",
    title: "hero-title",
    sub: "hero-sub",
    primaryCta: "hero-primary-cta",
    secondaryCta: "hero-secondary-cta",
    clock: "hero-clock",
  },
  services: {
    card: (slug) => `service-card-${slug}`,
    detailTitle: "service-detail-title",
    detailCta: "service-detail-cta",
  },
  cities: {
    card: (slug) => `city-card-${slug}`,
    filter: "cities-filter-input",
    detailTitle: "city-detail-title",
    detailCta: "city-detail-cta",
  },
  contact: {
    form: "contact-form",
    fullName: "contact-full-name",
    company: "contact-company",
    subject: "contact-subject",
    message: "contact-message",
    city: "contact-city",
    submit: "contact-submit",
    success: "contact-success",
  },
  quote: {
    form: "quote-form",
    step: (n) => `quote-step-${n}`,
    next: "quote-next",
    prev: "quote-prev",
    submit: "quote-submit",
    success: "quote-success",
    field: (name) => `quote-field-${name}`,
  },
  footer: {
    root: "footer-root",
    newsletter: "footer-newsletter-input",
    subscribe: "footer-subscribe-btn",
  },
};
